import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  name?: string;
  email?: string;
  photo?: string | null;
  className?: string;
}

/**
 * Get initials from a name string
 * "Luis Pillaga" → "LP"
 * "Nicolas" → "N"
 * "" → fallback to first letter of email or "U"
 */
function getInitials(name: string | undefined, email: string | undefined): string {
  if (name && name.trim()) {
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return `${words[0]?.charAt(0) ?? ''}${words[1]?.charAt(0) ?? ''}`.toUpperCase();
    }
    return words[0]?.charAt(0).toUpperCase() ?? 'U';
  }
  // Fallback to email
  if (email) {
    return email.charAt(0).toUpperCase();
  }
  return 'U';
}

export function UserAvatar({ name, email, photo, className }: UserAvatarProps) {
  const initials = getInitials(name, email);

  return (
    <Avatar className={cn('h-8 w-8', className)}>
      {photo && <AvatarImage src={photo} alt={name ?? 'Usuario'} />}
      <AvatarFallback className="bg-primary text-primary-foreground">{initials}</AvatarFallback>
    </Avatar>
  );
}
